(ns frontend.view.components.power-search.no-results.view
  (:require
   [common.localization :as loc]
   [common.schema.entity-type-names :as etn]
   [clojure.string :as s]
   [frontend.view.entity :as entity]
   [re-frame.core :as rf]
   [frontend.view.components.power-search.sub :as sub]
   [frontend.view.components.power-search.event :as event]
   [ui.components.button.view :as button]))

(defn create-button
  [entity-type]
  [button/sm-secondary-hollow
   {:on-click (fn []
                (entity/open-creator! entity-type {:start-value @(rf/subscribe [::sub/query])})
                (rf/dispatch [::event/close]))}
   "Create new "
   [:b
    (s/lower-case (etn/get-name entity-type :en))]
   " '"
   @(rf/subscribe [::sub/query])
   "'."])

(defn no-results
  []
  (let [query @(rf/subscribe [::sub/query])]
    (if (empty? query)
      [:div
       {:class "m-0 p-3 flex gap-4 flex-col text-sm"}]
      [:div
       {:class "m-0 p-3 flex gap-4 flex-col text-sm"}
       (loc/tr :search-no-results-for [query])
       [:div
        {:class "flex gap-2 flex-wrap"}
        [create-button :entity.type/company]
        [create-button :entity.type/person]]])))
